import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HttpClienteService {

  constructor(private http: HttpClient) { }

  get(url: string): Observable<any> {
    return this.http.get(url);
  }

  post(url: string, data: any, aditionalConfig: object = {}): Observable<any> {
    return this.http.post(url, data, aditionalConfig);
  }
  postImg(url: string, data: any): Observable<any> {
    return this.http.post(url, data);
  }

  delete(url: string, data:any): Observable<any> {
    return this.http.delete(url, data);
  }

  put(url: string, data: any): Observable<any> {
    return this.http.put(url, data);
  }


  patch(url: string, data: any): Observable<any> {
    return this.http.patch(url, data);
  }

}
